<template>
  <el-drawer 
    class="drawer" 
    id="branch_detail_drawer" 
    :withHeader="false" 
    :show-close="false" 
    :destroy-on-close="true" 
    :visible.sync="isVisible" 
    size="90%"
    direction="btt"
  >
    <div>
      <h1 class="text-title text-xs-center ma--0 py--4">{{ branchDetail.name }}</h1>
      <div class="px--4 pb--2">
        <div class="truncate">
          <img class="mr--2" :src="require('@/assets/icons/svg/pointer-active.svg')" />
          <span class="text-subtitle">{{ branchDetail.address }}</span>
        </div>
        <div class="mt--2 pl--5" v-if="distanceInfo">
          <img 
            v-show="receivingType === 'delivery'" 
            :src="require('@/assets/icons/svg/delivery-gray.svg')" 
          />
          <span 
            v-if="receivingType === 'delivery' && distanceInfo.price && distanceInfo.status === 'normal'" 
            class="mx--1 text-subtitle color-charcoal--text" 
          >
            {{ distanceInfo.price | priceFormat(0,$store.getters.currency) }}
            <span>•</span>
          </span>
          <span 
            v-if="distanceInfo.dis_metre" 
            class="text-subtitle color-charcoal--text"
          >
            {{ distanceInfo.dis_metre }} {{ $t('global.kilometer') }}
          </span>
        </div>
        <div 
          class="my--4 color-gray93" 
          style="border-radius: 6px; height:180px;" 
        > 
          <Gmap
            :position="branchPosition" 
            :marker-icon="require('@/assets/icons/svg/pin.svg')"
            :marker-size="{ height: 50, width: 50 }"
            :readonly="true"
            :zoom="14"
          />
        </div>
      </div>
		  <el-divider class="color-whitesmoke ma--0 overide-divider" />
      <div class="px--4">
        <h3 class="text-heading2--bold ma--0 pt--4">
          {{ $t('drawer.branchDetail.restaurantInfo') }}
        </h3>
        <div 
          v-if="branchDetail.phone" 
          class="detail-item" 
          @click="openContact(branchDetail.phone, 'tel')"
        >
          <img class="mr--3 vertical-middle" :src="require('@/assets/icons/svg/call.svg')" />
          <span class="text-heading3 color-cloudburst--text">{{ toTelephoneNumber(branchDetail.phone) }}</span>
        </div>

        <div 
          v-if="Object.keys(branchOpeningTimes).length"
          class="detail-item"
        >
          <div class="d-flex" v-for="(openingTime, index) in branchOpeningTimes" :key="index">
            <img class="mr--3 vertical-middle" :src="require('@/assets/icons/svg/clock.svg')"/>
            <span class="text-heading3 color-cloudburst--text">
              {{ getOpeningTimeMessage(openingTime) }}
            </span>
          </div>
        </div>


        <div 
          v-if="branchDetail.fbMessenger" 
          class="detail-item" 
          @click="openContact(branchDetail.fbMessenger, 'facebook')"
        >
          <img class="mr--3 vertical-middle" :src="require('@/assets/icons/svg/facebook.svg')"/>
          <span class="text-subtitle color-cloudburst--text">
            {{ branchDetail.fbMessenger }}
          </span>
        </div>

        <div 
          v-if="branchDetail.lineName"
          class="detail-item" 
          @click="branchDetail.line ? 
            openContact(branchDetail.line) : 
            openContact(branchDetail.lineName, 'line')
          "
        >
          <img class="mr--3 vertical-middle" :src="require('@/assets/icons/svg/line.svg')"/>
          <span class="text-subtitle color-cloudburst--text">{{ branchDetail.lineName }}</span>
        </div>

        <div 
          v-if="branchDetail.wlbComment"
          class="detail-item"
        >
          <img class="mr--2 vertical-middle" :src="require('@/assets/icons/svg/infomation.svg')"/>
          <span class="text-subtitle--bold">{{ $t('drawer.branchDetail.moreInfo') }}</span><br>
          <span class="text-subtitle color-cloudburst--text ml--9">{{ branchDetail.wlbComment }}</span>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import contact from '@/utils/contact'
import Mixins from '@/utils/mixins'

import Gmap from '@/components/element/Gmap.vue'

  export default {
    name: "BranchDetailDrawer",
    components: { Gmap },
    mixins: [Mixins],
    props: {
      value: { default: false },
      receivingType: { default: '' },
      branchDetail: { default: () => ({}) },
      distanceInfo: { default: () => ({}) },
    },
    computed: {
      isVisible: {
        get: function() { return this.value },
        set: function(value) { this.$emit('input', value) }
      },
      branchPosition: function() {
        const { latitude = 0, longitude = 0 } = this.branchDetail
        return { lat: latitude, lng: longitude }
      },
      // { '08:00-18:00': { days: [1, 2, 3, 4], open: '08:00', close: '18:00' } }
      branchOpeningTimes: function() {
        const openingTimes = this.branchDetail.openingTimes || []
        const openingTimesFormatted = this.formatOpeningTimes(openingTimes)
        const openingTimesSorted = this.sortOpeningTimes(openingTimesFormatted)
        const openingTimeGrouped = this.groupByOpenAndCloseTime(openingTimesSorted)
        return openingTimeGrouped
      }
    },
    methods: {
      openContact: contact.openContact,
			toTelephoneNumber: contact.toTelephoneNumber,
      formatOpeningTimes: function(openingTimes = []) {
        const openingTimesFormatted = []
        for (const item of openingTimes) {
          for (const day of item.day_id_list) {
            openingTimesFormatted.push({
              day,
              open: item.open_time, 
              close: item.close_time 
            })
          }
        }
        return openingTimesFormatted;
      },
      sortOpeningTimes: function(openingTimesFormatted = []) {
        // [{ day: 0 }, { day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 5 }, { day: 6 }]
        const sortedByASC = openingTimesFormatted.sort((a, b) => a.day - b.day)
        // [{ day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 5 }, { day: 6 }, { day: 0 }]
        const sortedByDay = sortedByASC.filter(item => item.day).concat(sortedByASC.filter(item => !item.day))
        return sortedByDay
      },
      groupByOpenAndCloseTime: function(openingTimesFormatted = []) {
        return openingTimesFormatted.reduce((acc, item) => {
          const key = item.open + '-' + item.close
          const collection = acc[key] && acc[key].days || []
          acc[key] = { days: collection.concat(item.day), open: item.open, close: item.close }
          return acc
        }, {})
      },
      getOpeningTimeMessage: function({ days = [], open = '', close = '' }) {
        if (!days.length) return ''

        const to = this.$t('global.to')
        const and = this.$t('global.and')
        const openEveryday = this.$t('drawer.branchDetail.openEveryday')

        const openClose = open + ` ${to} ` + close
        const dayWithTextList = this.getDaysFromNumbers(days)

        // Ex. จันทร์ 08:00 จนถึง 18:30
        const hasOne = dayWithTextList.length === 1
        if (hasOne) return `${dayWithTextList[0].text} ${openClose}`

        const isDaysSortingStrictly = this.isDaysSortingStrictly(dayWithTextList)
        const hasAll = dayWithTextList.length === 7

        // Ex. เปิดทุกวัน 08:00 จนถึง 18:30
        if (hasAll && isDaysSortingStrictly) return `${openEveryday} ${openClose}`

        // Ex. จันทร์ - ศุกร์ 08:00 จนถึง 18:30
        const lastIndex = dayWithTextList.length - 1
        if (isDaysSortingStrictly) return `${dayWithTextList[0].text} - ${dayWithTextList[lastIndex].text} ${openClose}`

        // Ex. จันทร์ พุธ และ ศุกร์ 08:00 จนถึง 18:30
        const daysJoined = dayWithTextList.slice(0, lastIndex).map(day => day.text).join(' ')
        return `${daysJoined} ${and} ${dayWithTextList[lastIndex].text} ${openClose}`
      },
      getDaysFromNumbers: function(nums = []) {
        const lang = this.$i18n.locale
        const numsSorted = nums.sort()
        // [1, 2, 3, 4, 5, 6, 0]
        const days = numsSorted[0] === 0 ? [].concat(numsSorted.filter(day => day), 0) : numsSorted
        const dayWithTextList = days.map(day => ({ 
          text: lang === 'th' ? this.filter_long_day_th(day) : this.filter_long_day_en(day), 
          value: day 
        }))
        return dayWithTextList
      },
      isDaysSortingStrictly: function(dayWithTextList = []) {
        const nextDayOf = {
          0:1,
          1:2,
          2:3,
          3:4,
          4:5,
          5:6,
          6:0
        }
        for (let i=0; i < dayWithTextList.length - 1; i++) {
          const cur = dayWithTextList[i].value
          const next = dayWithTextList[i + 1].value
          if (next !== nextDayOf[cur]) {
            return false
          }
        }
        return true
      },
    },
  }
</script>

<style lang="scss" scoped>
.overide-divider {
  height: 8px;
}

.detail-item {
  padding: 12px 0;
  border-bottom: 0.5px solid var(--color-gray93);
  
  &:last-child {
    border-bottom: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/menu/BranchDetailDrawer.vue